import type { PageContext } from "vike/types";
import { htmlEntityEncodeV2 } from "@/services/v1/utils";

export function title(
	pageContext: PageContext<{
		body?: {
			instanceConfig?: {
				meta?: {
					title: string;
				};
			};
		};
	}>
) {
	const { title } = pageContext.data.body?.instanceConfig?.meta || {};

	return typeof title === "string" ? htmlEntityEncodeV2(title) : "";
}
